import { Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { PermissionUtils } from 'utils'
import SimulatorTrainingStudentILTrainingDetailsRouting, {
  routes as simulatorTrainingStudentILTrainingDetailsRoutes,
} from 'modules/simulatorTrainings/student/instructorLed/TrainingDetails/routing'
import SimulatorTrainingStudentSlTrainingDetailsRouting, {
  routes as simulatorTrainingStudentSlTrainingDetailsRoutes,
} from 'modules/simulatorTrainings/student/studentLed/TrainingDetails/routing'
import routes from './routes'

const { RouteChangeProgress } = common

const SimulatorTrainingStudentRouting = () => {
  const simulatorTrainingInstructorLedDenied =
    PermissionUtils.simulatorTrainingInstructorLedDenied()
  const simulatorTrainingStudentLedDenied = PermissionUtils.simulatorTrainingStudentLedDenied()
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <Switch>
        <PrivateRoute
          path={simulatorTrainingStudentILTrainingDetailsRoutes.root}
          component={SimulatorTrainingStudentILTrainingDetailsRouting}
          disabled={simulatorTrainingInstructorLedDenied}
        />
        <PrivateRoute
          path={simulatorTrainingStudentSlTrainingDetailsRoutes.root}
          component={SimulatorTrainingStudentSlTrainingDetailsRouting}
          disabled={simulatorTrainingStudentLedDenied}
        />
        <Redirect path='*' to={routes.root} />
      </Switch>
    </Suspense>
  )
}

export default SimulatorTrainingStudentRouting
